module.exports = __webpack_public_path__ + "static/016-e7cc057e6cccb4abf4196f47e051aad1.jpg";